/** @jsxImportSource @emotion/react */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { jsx, css } from '@emotion/react'
import CallHistory from './CallHistory'

class Home extends Component {

    render() {
        return (
            <>
              <CallHistory active_key="home" />
            </>
        )
    }
}

export default Home
